import React, { useEffect, useState } from 'react'

import BreifcaseIcon from '../../icons/ps_general_breifcase.svg?react'
import CalendarIcon from '../../icons/ps_general_calendar.svg?react'
import ClipboardIcon from '../../icons/ps_general_clipboard.svg?react'
import CreditCardIcon from '../../icons/ps_general_credit_card.svg?react'
import FileIcon from '../../icons/ps_general_file.svg?react'
import GlobeIcon from '../../icons/ps_general_globe.svg?react'
import HashIcon from '../../icons/ps_general_hash.svg?react'
import HomeIcon from '../../icons/ps_general_home.svg?react'
import LocationIcon from '../../icons/ps_general_location.svg?react'
import MessageCircleIcon from '../../icons/ps_general_message_circle.svg?react'
import UsersIcon from '../../icons/ps_general_users.svg?react'
import ZapIcon from '../../icons/ps_general_zap.svg?react'
import ServicesIcon from '../../icons/ps_settings_services_nobg.svg?react'
import { Dashboard } from '../../models/Dashboard'
import { RecordFactory } from '../../models/RecordFactory'
import { ReportImageType, ReportResult } from '../../models/ReportResult'
import { ContactAvatar } from '../contacts/ContactAvatarV1'
import { DashboardIcon } from '../dashboards/DashboardIcon'

type ReportIconProps = {
    result: ReportResult
}

export const ReportIcon: React.FC<ReportIconProps> = ({ result }) => {
    const [icon, setIcon] = useState<React.ReactElement | null>(null)

    useEffect(() => {
        const loadIcon = async () => {
            let iconElement: React.ReactElement

            if (
                result.imageType === ReportImageType.ReportImageTypeInitials &&
                (result.type === 'user' || result.person)
            ) {
                const user =
                    result.type === 'user'
                        ? await RecordFactory.getInstance().loadUser(result.id!)
                        : result.person
                if (user?.image?.url) {
                    iconElement = <img src={user.image.url} />
                }
                else if (user) {
                    iconElement = <ContactAvatar user={user} size="large" />
                }
                else {
                    iconElement = <UsersIcon />
                }
            }
            else if (
                result.imageType === ReportImageType.ReportImageTypeImage &&
                result.imageUri
            ) {
                iconElement = <img src={result.imageUri} alt={result.title} />
            }
            else {
                if (result.type === 'item_type') {
                    if (result.id === 'service')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'bookings' }),
                        })
                    else if (result.id === 'reservation')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'reservations' }),
                        })
                    else if (result.id === 'product')
                        iconElement = DashboardIcon({ dashboard: new Dashboard({ id: 'orders' }) })
                    else if (result.id === 'invoice')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'invoices' }),
                        })
                    else if (result.id === 'package')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'packages' }),
                        })
                    else if (result.id === 'gift')
                        iconElement = DashboardIcon({ dashboard: new Dashboard({ id: 'gifts' }) })
                    else if (result.id === 'payment')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'deposits' }),
                        })
                    else if (result.id === 'charge')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'deposits' }),
                        })
                    else if (result.id === 'estimate')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'estimates' }),
                        })
                    else if (result.id === 'subscription')
                        iconElement = DashboardIcon({
                            dashboard: new Dashboard({ id: 'subscriptions' }),
                        })
                    else if (result.id === 'class')
                        iconElement = DashboardIcon({ dashboard: new Dashboard({ id: 'classes' }) })
                    else iconElement = <BreifcaseIcon />
                }
                else if (result.type === 'source_type') {
                    iconElement = <CreditCardIcon />
                }
                else if (result.type === 'source') {
                    iconElement = <ZapIcon />
                }
                else if (result.type === 'item') {
                    iconElement = <ClipboardIcon />
                }
                else if (
                    result.type === 'subaccount' ||
                    result.type === 'vendor' ||
                    result.type === 'employee' ||
                    result.type === 'client'
                ) {
                    iconElement = <UsersIcon />
                }
                else if (result.type === 'state') {
                    iconElement = <GlobeIcon />
                }
                else if (result.type === 'city') {
                    iconElement = <HomeIcon />
                }
                else if (result.type === 'postal_code') {
                    iconElement = <HashIcon />
                }
                else if (result.type === 'category' || result.type === 'date') {
                    iconElement = <CalendarIcon />
                }
                else if (result.type === 'transaction_type' || result.type === 'expense_type') {
                    iconElement = <FileIcon />
                }
                else if (result.type === 'field') {
                    iconElement = <MessageCircleIcon />
                }
                else if (result.location) {
                    iconElement = <LocationIcon />
                }
                else {
                    iconElement = <ServicesIcon />
                }
            }

            setIcon(iconElement)
        }

        loadIcon()
    }, [result])

    return icon
}
